import TeamTimeSheetTable from "components/tables/practice/TeamTimeSheetTable";

const TeamTimeSheet = () => {
  return (
    <>
    <div className="admin-practice-details">
     <TeamTimeSheetTable />
    </div>
    </>
  );
};

export default TeamTimeSheet;
